// export const BASE_URL = 'https://transporters-api.webtitans.gr'
export const APP_VERSION = '1.2.3'
export const BASE_URL = 'https://transporters.webtitans.gr'
export const API_BASE_URL = `${BASE_URL}/api`
export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiY2tlc2lzaXM5NCIsImEiOiJjbTFuZW4yazMwdGw0MmpzZ2oxeDNjeG96In0.BbQOs-QOf7TnHR6GmMhcTg'
